<div class="d-flex justify-content-between">
    <mat-card-title class="m-l-10">Leads</mat-card-title>
    <!-- 
    <button mat-flat-button color="primary" class="w-50">
        <span><mat-icon>add_box</mat-icon></span>
        Add
    </button> -->
    <input type="file" (change)="onFileSelected($event)" #fileInput style="display: none;" accept=".csv, .xls, .xlsx">
    <a (click)="fileInput.click()" mat-flat-button color="primary" class="responsive-button d-none">

        <!-- <mat-icon>add_box</mat-icon> -->
        import csv
    </a>
</div>
<mat-card class="cardWithShadown m-t-20">
    <mat-card-content>
        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                <!--- Note that these columns can be defined in any order.
                          The actual rendered columns are set as a property on the row definition" -->

                <!-- Position Column -->
                <ng-container matColumnDef="leadsId">
                    <th mat-header-cell *matHeaderCellDef> Sr. </th>
                    <td mat-cell *matCellDef="let element"> {{element.position}} </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="notes">
                    <th mat-header-cell *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef> Email </th>
                    <td mat-cell *matCellDef="let element"> {{element.weight}} </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="phoneNumber">
                    <th mat-header-cell *matHeaderCellDef> Phone Number </th>
                    <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="budget">
                    <th mat-header-cell *matHeaderCellDef>Budget</th>
                    <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="commission">
                    <th mat-header-cell *matHeaderCellDef> Commission </th>
                    <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="assignedAgents">
                    <th mat-header-cell *matHeaderCellDef> Assigned Agents </th>
                    <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef> Status </th>
                    <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
                </ng-container>

                <!-- Symbol Column -->
                <!-- <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
                    </ng-container> -->


                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> Action </th>
                    <td mat-cell *matCellDef="let element">
                        <!-- Dropdown Button -->
                        <button mat-button [matMenuTriggerFor]="menu"><i
                                class="fa-solid fa-ellipsis-vertical"></i></button>

                        <!-- Dropdown Menu -->
                        <mat-menu #menu="matMenu" class="">
                            <div>
                                <button mat-button (click)="leadViewDetail(element)">
                                    <mat-icon>remove_red_eye</mat-icon>View</button>
                            </div>
                            <div>
                                <button mat-button (click)="edit(element)"><mat-icon>edit</mat-icon>Edit</button>
                            </div>
                            <div>
                                <button mat-button (click)="deleteItem(element)">
                                    <mat-icon>delete</mat-icon>Delete</button>
                            </div>
                            <!-- <button mat-menu-item (click)="onAction3(element)">Action 3</button> -->
                        </mat-menu>
                    </td>
                </ng-container>

                <ng-container matColumnDef="">
                    <!-- <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let row">
                            <button mat-button (click)="delete(row)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td> -->
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <mat-paginator #paginator [length]="dataSource.length" [pageIndex]="0" [pageSize]="10"
            [pageSizeOptions]="[25, 50, 100, 250]">
        </mat-paginator>
    </mat-card-content>
</mat-card>